import React from 'react';
import { STAGE_LAYOUT, StageLayout } from '../consts';

export interface DisplayOptions {
    stageLayout: StageLayout;
}

export interface DisplayContextOptions extends DisplayOptions {
    setStageLayout(stageLayout: StageLayout): void;
}

// Отвечает за переключение вида экрана и показ статистики
export const DisplayContext = React.createContext<DisplayContextOptions>({
    stageLayout: STAGE_LAYOUT.GRID,
    setStageLayout: () => {
        return;
    },
});
